import React from "react";
import UploadCard from "../components/UploadCard";

const UploadCardScreen = (props) => {
  return <UploadCard {...props} />;
};
export default UploadCardScreen;
